/* istanbul ignore file */
import { Show } from 'framework/show';
import React from 'react';
import { useAssetId } from 'domain/finance/assets/shared/useAssetRouting';
import useAssetService from 'domain/finance/assets/useAssetService';

const ShowAsset = ({ children }: { children: React.ReactNode }) => {
  const { getById } = useAssetService();
  const id = useAssetId();

  return <Show getDataMethod={() => getById(id)}>{children}</Show>;
};

export default ShowAsset;
